export const FINANCIAL_ANALYST_LDAP_GROUP = 'fintech-merp-financial-analyst';

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
